export const getAllContentLabels = (state) => state.workshop.contentLabels;
export const getIsLoadingContentLabels = (state) => state.workshop.isLoading;
export const getLoadingTopicLabelIds = (state) =>
  state.workshop.loadingTopicLabelIds;
export const getSelectedGroup = (state) => state.workshop.selectedGroup;
export const getSelectedContentLabel = (state) =>
  state.workshop.selectedContentLabel;
